const fieldLabelClass = "tw-font-bold tw-text-[13px] tw-mb-[4px] tw-leading-[24px] tw-tracking-[0.15px] tw-block";
export const FieldLabel = ({
  htmlFor,
  label,
  required,
  className,
}: {
  htmlFor: string;
  label: string;
  required?: boolean;
  className?: string;
}) => {
  return (
    <label htmlFor={htmlFor} className={`${fieldLabelClass} ${className || ""}`}>
      {label}
      {required && <span className='tw-ml-1 tw-text-red'>*</span>}
    </label>
  );
};
FieldLabel.labelClass = fieldLabelClass;
